module.exports = __webpack_public_path__ + "img/loginRefresh.e912c851.svg";